/**
 * Rozcestník rozděleného košíku (zboží + servis) — ClickUp #86cb6vgt2.
 *
 * Rozcestník `[data-basket-switch]` se lepí pod hlavní menu (CSS sticky) a zvýrazňuje košík
 * `[data-basket-section]`, ve kterém návštěvník právě je. Odstup od menu i odsazení cíle kotvy
 * se počítá z výšky menu a rozcestníku, protože obě se mění podle šířky okna (na mobilu jsou
 * vyšší) — pevný offset `anchor-displacement-block` sticky rozcestník nezná (viz knowledge/kotvy.md).
 */

const ACTIVE_CLASS = 'btn-basesp';
const INACTIVE_CLASS = 'btn-blocksp';

export function initialize(): void {
    let switcher = document.querySelector('[data-basket-switch]');

    if (!(switcher instanceof HTMLElement)) {
        return;
    }

    let box: HTMLElement = switcher;
    let links = Array.from(box.querySelectorAll('a[href^="#"]')).filter(function (link): link is HTMLAnchorElement {
        return link instanceof HTMLAnchorElement;
    });
    let sections = Array.from(document.querySelectorAll('[data-basket-section]')).filter(function (section): section is HTMLElement {
        return section instanceof HTMLElement;
    });

    if (links.length === 0 || sections.length === 0) {
        return;
    }

    let offset = 0;

    function measure(): void {
        let nav = document.getElementById('navbar_top');
        let navHeight = nav !== null ? nav.offsetHeight : 0;

        box.style.setProperty('--basket-switch-top', navHeight + 'px');
        offset = navHeight + box.offsetHeight;

        sections.forEach(function (section) {
            section.style.scrollMarginTop = offset + 'px';
        });
    }

    function highlight(): void {
        // aktuální je poslední košík, jehož začátek už dojel pod rozcestník; na konci stránky poslední,
        // i když je tak krátký, že pod rozcestník nedojede
        let current = sections[0];
        let scrollHeight = document.documentElement.scrollHeight;
        let atBottom = scrollHeight > window.innerHeight && window.innerHeight + window.scrollY >= scrollHeight - 2;

        sections.forEach(function (section) {
            if (section.getBoundingClientRect().top <= offset + 1) {
                current = section;
            }
        });

        if (atBottom) {
            current = sections[sections.length - 1];
        }

        links.forEach(function (link) {
            let active = link.hash === '#' + current.id;

            link.classList.toggle(ACTIVE_CLASS, active);
            link.classList.toggle(INACTIVE_CLASS, !active);

            if (active) {
                link.setAttribute('aria-current', 'location');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }

    let scheduled = false;
    let measureNeeded = false;

    // scroll i resize jen jednou za snímek; měření (čte výšky) jen po resize
    function schedule(): void {
        if (scheduled) {
            return;
        }

        scheduled = true;
        window.requestAnimationFrame(function () {
            scheduled = false;

            if (measureNeeded) {
                measureNeeded = false;
                measure();
            }

            highlight();
        });
    }

    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            let target = document.getElementById(link.hash.slice(1));

            // nová karta / okno (Ctrl, Cmd, Shift, Alt) nechat prohlížeči
            if (target === null || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                return;
            }

            e.preventDefault();
            target.scrollIntoView({block: 'start', behavior: 'smooth'});
            history.replaceState(null, '', link.hash);
        });
    });

    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', function () {
        measureNeeded = true;
        schedule();
    });

    measure();

    // načtení s #kotvou košíku (odkaz z děkovací stránky): prohlížeč odscrolloval podle zálohy v SCSS,
    // dorovnat na přesný odstup — Chrome scroll při load opakuje, Firefox a Safari ne vždy
    let initial = sections.find(function (section) {
        return location.hash === '#' + section.id;
    });

    if (initial !== undefined) {
        initial.scrollIntoView({block: 'start'});
    }

    highlight();
}
